import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { RedesignedNewbuildingRecommendations as RedesignedNewbuildingRecommendationsView } from '../../components/RedesignedNewbuildingRecommendations';
import { ELoadingStatus } from '../../types/loadingStatus';
import { useNewbuildingRecommendations } from './useNewbuildingRecommendations';

type TRedesignedNewbuildingRecommendationsProps = {
  className?: string;
};

export const RedesignedNewbuildingRecommendations: React.FC<TRedesignedNewbuildingRecommendationsProps> = ({
  className,
}) => {
  const { newbuildings, recommendationsStatus, onRecommendationsShow, onCardClick } = useNewbuildingRecommendations();

  if (recommendationsStatus !== ELoadingStatus.Success || !newbuildings.recommendations.length) {
    return null;
  }

  const content = (
    <ActionAfterViewed callback={onRecommendationsShow}>
      <RedesignedNewbuildingRecommendationsView
        recommendations={newbuildings.recommendations}
        onCardClick={onCardClick}
      />
    </ActionAfterViewed>
  );

  return className ? <div className={className}>{content}</div> : content;
};
